/*jshint maxparams: 30 */
import bootLayout from 'static/script/app/boot/boot-layout';
import BiddingEvents from 'static/script/app/data/bidding-events';
import PrefilledInput from 'static/script/app/ui/prefilled-input';

export default initData => {
    bootLayout(initData);
    BiddingEvents.attachTo(document, { initialState: initData.pageSpecificData.biddingState });
    PrefilledInput.attachTo(document);
};


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/pages/bidding.js